import { render, staticRenderFns } from "./testimonialPersonGraphTab.vue?vue&type=template&id=0b4e413c"
import script from "./testimonialPersonGraphTab.vue?vue&type=script&lang=js"
export * from "./testimonialPersonGraphTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4e413c')) {
      api.createRecord('0b4e413c', component.options)
    } else {
      api.reload('0b4e413c', component.options)
    }
    module.hot.accept("./testimonialPersonGraphTab.vue?vue&type=template&id=0b4e413c", function () {
      api.rerender('0b4e413c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testimonialPersonGraphTab.vue"
export default component.exports